
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.582 7.716l4.417 2.558 4.383-2.542M9.998 14.807v-4.542","stroke":"#fff","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M8.966 5.241L6.299 6.725C5.7 7.058 5.2 7.9 5.2 8.59v2.825c0 .692.492 1.534 1.1 1.867l2.667 1.483c.567.317 1.5.317 2.075 0l2.667-1.483c.6-.333 1.1-1.175 1.1-1.867V8.583c0-.692-.492-1.533-1.1-1.867L11.04 5.233c-.575-.317-1.508-.317-2.075.008zM18.333 12.5a5.829 5.829 0 01-5.833 5.833l.875-1.458M1.666 7.5a5.83 5.83 0 015.833-5.834l-.875 1.459","stroke":"#fff","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    